import React from "react";
import BarraMulticolor from "../assets/barraMulticolor.svg";
import { Esercizio } from "../interfaces/Esercizio";

interface ProgressBarODMProps {
  title: string;
  levels: number;
  value: number | null;
  field: keyof Esercizio;
  onChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
}

const ProgressBarODM: React.FC<ProgressBarODMProps> = ({ title, levels, value, field, onChange }) => {
  return (
    <>
      <h5 className="font-semibold mb-3">{title}</h5>
      <div className={`row row-cols-${levels} text-center`}>
        {[...Array(levels)].map((_, index) => (
          <div className="col" key={index}>
            <button
              className={`btn ${value === index + 1 ? "btn-dark" : "btn-light"} flex-1`}
              onClick={() => onChange(field, index + 1 as Esercizio[keyof Esercizio])}
            >
              {index + 1}
            </button>
          </div>
        ))}
      </div>

      <img src={BarraMulticolor} alt="Progress Bar" style={{ width: "100%" }} />
    </>
  );
};

export default ProgressBarODM;

